import React from 'react';
import { IconSizesEnum } from '@/enums/styling';
import { getTailwindClassByEnum } from '@/utils/cssHelpers';
import { compose } from '@/utils/story-composer';
import Image from '@/components/elements/image';

function Icon({ asset, size, elementProps }) {
	const iconSizeClass = getTailwindClassByEnum(IconSizesEnum, size);

	return <Image {...elementProps} appearance={iconSizeClass} src={asset.filename} alt={asset.alt || ''} />;
}

export default Icon;
compose('icon', Icon);
